export default __webpack_public_path__ + "static/media/File No. 30.c45673be.pdf";